import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddCompanyBenefitsWizard.scss';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { withRouter } from 'react-router';
import * as _ from 'lodash';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import {
  createCompanyBenefit,
  listCompanyBenefits,
} from '../redux/actions/table/company_benefits';
import AddCompanyIcon from '../assets/images/add-company-60x60.svg';
import AddCompanyBenefitsForm from '../forms/add_company_benefits_wizard/AddCompanyBenefitsForm';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['company_benefits'],
}))
@subscribe(Localization, 'localization')
class AddCompanyBenefitsWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    return validateForm(
      createCompanyBenefit(formData).then(({ response }) => {
        listCompanyBenefits();

        setNotification(__('wizard.add-company-benefit.confirm'));

        this.props.onClose();
      })
    );
  }

  render() {
    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>{__('wizard.add-company-benefits.title.create-new')}</span>
            <span>{__('wizard.add-company-benefits.subtitle.create-new')}</span>
          </div>
          <div className={styles.right}>
            <AddCompanyIcon />
          </div>
        </div>
        <div className={styles.body}>
          <AddCompanyBenefitsForm onSubmit={this._handleSubmit} />
        </div>
      </>
    );
  }
}

export default AddCompanyBenefitsWizard;
